// extracted by mini-css-extract-plugin
export default {"crumb":"breadcrumbs_crumb__YyFqX","crumb__active":"breadcrumbs_crumb__active__c+ttt","crumb__separator":"breadcrumbs_crumb__separator__HIl33","crumbs":"breadcrumbs_crumbs__3Ddvf"};